// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".current-width[data-v-ffc4eb8e]{width:25px;display:inline-block}@media only screen and (max-width:768px){.current-width[data-v-ffc4eb8e]{width:18px}}.slick-initialized .slick-active[data-v-ffc4eb8e]{z-index:10}.landing-intro-alt[data-v-ffc4eb8e]{margin-top:-70px}@media only screen and (max-width:768px){.landing-intro-alt[data-v-ffc4eb8e]{margin-top:-80px;height:484px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
